"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Object.freeze({
    authentication: 'authentication',
    localization: 'localization',
    product: 'product',
    storeAvailability: 'storeAvailability',
    store: 'store'
});
//# sourceMappingURL=CacheStoreType.js.map